import request from '@/utils/request'

/**
 * 获取分销访问记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回分销访问记录列表
 */
export function listAffiliateVisit(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateVisit.listAffiliateVisit',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除分销访问记录
 * @param {Object} data 删除参数
 * @returns {Promise} 返回删除结果
 */
export function deleteAffiliateVisit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateVisit.deleteAffiliateVisit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}